import React from "react";
import { useAuth } from "../../components/context/AuthContext";
import { Navigate, Link } from "react-router-dom";

function Accueil() {
  const { user } = useAuth();

  if (user) {
    return <Navigate to="/murs" />;
  }

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Bienvenue sur Kass-Brick 🧱</h1>
      <h2>Pour commencer, veuillez vous connecter ou créer un compte.</h2>
      <Link  to="/connexion" className="retro-link">Se connecter</Link> | <Link  to="/inscription" className="retro-link">Créer un compte</Link>
    </div>
  );
}

export default Accueil;